<ng-container *ngIf="link?.item">
    <div class="my-1 d-flex flex-row align-items-start note-action-container hover-container">
        <adapt-item-link [item]="link.item"
                         [showStatus]="showStatus"
                         [itemLinksDisabled]="itemLinksDisabled"
                         [closeAllDialogsOnDelete]="closeAllDialogsOnDelete"
                         [showSummary]="true"
                         (itemDialogClosed)="itemDialogClosed.emit($event)"></adapt-item-link>
        @if (showDeleteLink) {
            <button adaptButtonIcon="delete"
                    adaptTooltip="Delete action link"
                    (click)="deleteLink()"
                    class="ms-auto me-2 btn btn-blank hover-action"></button>
        }
    </div>
</ng-container>
